<template>
    <div class="slider" ref="slider">
        <ul class="slide-main swiper-wrapper">
            <li class="item swiper-slide" v-for="item in slide" :key="item.id">
                <a :href="item.url" :target="item.target == 1 ? '_self' : '_blank'">
                    <img :src="resourceUrl + item.image" :alt="item.title">
                    <p>{{item.title}}</p>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
import {resourceUrl} from '../common/util/config.js'
import Swiper from 'swiper'
export default {
	props: {
		slide: {
			type: Array,
			default: true
		}
	},
    data () {
        return {
        	resourceUrl
        }
    },
    mounted () {
    	this.$nextTick(function () {
    		  new Swiper(this.$refs.slider, {
		      wrapperClass: 'slide-main',
		      slideClass: 'item',
		      observer: true,
              observeParents: true
		    });
    	})
    }
}
</script>
<style lang="scss">
	.slider{
		overflow: hidden;
		.item{
			float:left;
			img{
				max-width: 100%;
			}
			p{
				position: absolute;
				bottom:0;
				left:0;
				width: 100%;
				 height:.7rem;
				 line-height: .7rem;
				 font-size: .3rem;
				 color: #fff;
				 background:rgba(0,0,0,0.5);
				 padding-left: .3rem;
				 box-sizing: border-box;
				 overflow: hidden;
				 white-space: nowrap;
				 text-overflow: ellipsis;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/slide.vue